import { Box, Card, CardContent, CardHeader } from '@material-ui/core';
import React from 'react';
import { useStatisticsContext } from '../contexts/StatistiquesProvider';
import style from '../../../features/statistiques/css/Statistics.module.scss';
import SGSPieChart from 'components/Charts/SGSPieChart';

type Props = {};

const ChoixAdhesion: React.FC<Props> = () => {
    const { choixAdhesion, isLoadingChoixAdhesion } = useStatisticsContext();

    return (
        <>
            <Card className="w-100" style={{ boxShadow: 'none' }}>
                <CardHeader title="Choix d'adhésion" className={style.graphsTitle} />
                <CardContent className={style.chartBox}>
                    <Box className={style.graphsDivider}></Box>
                    {!isLoadingChoixAdhesion ? (
                        <>
                            <SGSPieChart data={choixAdhesion} />
                        </>
                    ) : (
                        'Loading...'
                    )}
                </CardContent>
            </Card>
        </>
    );
};

export default ChoixAdhesion;
